import { render, staticRenderFns } from "./EmployeeManagement.vue?vue&type=template&id=267fc682&scoped=true&"
import script from "./EmployeeManagement.vue?vue&type=script&lang=js&"
export * from "./EmployeeManagement.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeManagement.vue?vue&type=style&index=0&id=267fc682&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267fc682",
  null
  
)

component.options.__file = "EmployeeManagement.vue"
export default component.exports